const features = [
  {
    image: 'https://front10.com/landing-page-book/images/features/speed.png',
    title: 'Easy & Fast',
    subtitle: 'Very easy and fast develop',
    summary: 'Zero config, Online playground, Lots of examples.',
    link: 'https://front10.com'
  },
  {
    image: 'https://front10.com/landing-page-book/images/features/themes.png',
    title: 'Theming',
    subtitle: 'Customize our components',
    summary:
      'Change the components colors, fonts, and look and feel in general using CSS variables.',
    link: 'https://front10.com'
  },
  {
    image: 'https://front10.com/landing-page-book/images/features/integration.png',
    title: 'Integration',
    subtitle: 'Can be used in many plattaforms',
    summary: 'Proven and painless integration with Create React App, GatsbyJS and NextJS.',
    link: 'https://front10.com'
  }
];

export default features;



// WEBPACK FOOTER //
// ./src/stories/mock/components/features.js